module.exports = __webpack_public_path__ + "img/all-monitors-dark.1f543a45.svg";